import { API } from "aws-amplify";

export type GetTokenDefinitionResponse = {
  link: string,
  credentials: {
    token: string,
    identityId: string
  }
}

export async function getTokenDefinition(token: string): Promise<GetTokenDefinitionResponse | undefined> {
  try {
    const path: string = `/temporary-access?token=${token}`;

    const data: APIResponse<GetTokenDefinitionResponse> = await API.get(
      'api-service',
      path,
      {}
    )

    return data.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
